import ReSignActionType from '../../common/ResignActionType';

const ReSignReducer = (state = {}, action) => {
  // eslint-disable-next-line no-console
  switch (action.type) {
    case ReSignActionType.STORE_RESIGN_RESPONSE:
      return {
        ...state,
        response: action.value
      };
    case ReSignActionType.STORE_CUSTOMER_INFO:
      return {
        ...state,
        info: action.value
      };
    default:
      return state;
  }
};

export const ReSignSelector = {
  customerInfo: state => state.reSign.info,
  reSignResponse: state => state.reSign.response
};

export default ReSignReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/ReSignReducer.js
 **/